import * as actionTypes from './actionTypes';

/* ----------------- Registration ------------------ */
export const visualMessageSet = ( message, scope, key, type, obj ) => {
    return {
        type: actionTypes.VISUALMESSAGE_SET,
        message: message,
        scope: scope,
        key: key,
        type: type,
        obj: obj
    };
};

export const visualMessageReset = () => {
    return {
        type: actionTypes.VISUALMESSAGE_RESET
    };
};


// WEBPACK FOOTER //
// ./src/_store/actions/visualMessage.js